//NODE MODULES
import ImageViewer from "awesome-image-viewer";

//KPP COMPONENTS
import { PageHeader } from "../components/helpers";

//3rd PARTY COMPONENTS
import { HiMagnifyingGlassPlus } from "react-icons/hi2";

//IMAGES
import av00 from "../assets/img/av/Aerial AV.jpg";
import av01 from "../assets/img/av/Aerial Photomontage AV.jpg";
import av02 from "../assets/img/av/Bar seating area AV.jpg";
import av03 from "../assets/img/av/Brenntag AV.jpg";
import av04 from "../assets/img/av/Caddick_Shillinghill AV.jpg";
import av05 from "../assets/img/av/CAM0C AV.jpg";
import av06 from "../assets/img/av/CAM01 AV.jpg";
import av07 from "../assets/img/av/Draft AV.jpg";
import av08 from "../assets/img/av/Front Unit with branding AV.jpg";
import av09 from "../assets/img/av/Globe Mill Final AV.jpg";
import av10 from "../assets/img/av/LC-03 HIRES AV.jpg";
import av11 from "../assets/img/av/Lower Cam Draft AV.jpg";
import av12 from "../assets/img/av/Main Cam AV.jpg";
import av13 from "../assets/img/av/Meeting Cam JPG AV.jpg";
import av14 from "../assets/img/av/Night Shot Entrance AV.jpg";

const KppAV = () => {
	const viewImages = (idx) => {
		const images = [av00, av01, av02, av03, av04, av05, av06, av07, av08, av09, av10, av11, av12, av13, av14].map((img, idx) => {
			return { mainUrl: img, thumbnailUrl: img, description: `KPP AV Example ${idx + 1}` };
		});
		new ImageViewer({
			images: images,
			currentSelected: idx,
			stretchImages: true,
			isZoomable: false,
		});
	};

	return (
		<>
			<PageHeader />

			<div className="content-width headerPadding marginTop-large marginBottom-large">
				<section className="summary plusPattern marginBottom-xlarge text-center">
					<p>
						KPP:AV offers <b>professional architectural 3D visualisation</b> services, providing high-quality imagery that brings <b>designs to life</b>.
					</p>

					<p>
						The company has supported the production of aerial masterplans, industrial units, offices, residential developments, and projects across other sectors.
						Specialising in the <b>creation of detailed visuals</b> for planning applications, marketing materials, and design development, KPP:AV has been
						collaborating with clients nationwide, helping architects, developers, and planners <b>communicate their visions with clarity and impact</b>.
					</p>
				</section>
				<section className="grid-columns-autoFill imageGallery-grid gap-min" style={{ "--_minSize": "40ch" }}>
					{/* <img src={featureImg_01} alt="test" />
					<img src={av02} alt="test" /> */}
					{[av00, av01, av02, av03, av04, av05, av06, av07, av08, av09, av10, av11, av12, av13, av14].map((img, idx) => (
						<div key={`avImage-${idx}`} className="imgHover-wrapper" onClick={() => viewImages(idx)}>
							<img src={img} alt={`KPP AV Example ${idx + 1}`} className="object-fit" />
							<div className="imgHover">
								<HiMagnifyingGlassPlus />
							</div>
						</div>
					))}
				</section>
			</div>
		</>
	);
};

export default KppAV;
